import { z } from "zod";
import { defineQuery } from "supabase/database/server.ts";

export const GetUserData = defineQuery(
  "getUserData",
  {
  input: z.object({
    table: z.string(),
    email: z.email()
  }),
  handler: async ({ db }, { table, email }) => {
    const { data, error } = await db
      .from(table)
      .select("*")
      .eq('user_email', email)
      .order('created_at', { ascending: false });
    if (error) throw error;
    return data;
  },
});

export const GetDataById = defineQuery(
  "getDataById",
  {
  input: z.object({
    table: z.string(),
    id: z.number()
  }),
  handler: async ({ db }, { table, id }) => {
    const { data, error } = await db
      .from(table)
      .select("*")
      .eq('id', id)
      .single();
    if (error) throw error;
    return data;
  },
});